<template>
  <div class="container-box">
    <div class="container-inner">
      <h2 class="title-type-1">계정 등록</h2>
      <v-form ref="form" v-model="valid">
        <div class="form-wrap">
          <div class="form-group mb-8">
            <h3 class="title-type-3">
              아이디
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6 pr-16">
              <v-text-field
                class="input-custom-2"
                height="40px"
                v-model="userId"
                :rules="idRules"
                solo
                required
                placeholder="6자 이상 영문/숫자 (대,소문자 구분) 20자 이내"
              ></v-text-field>
            </div>
          </div>

          <div class="form-group mb-8">
            <h3 class="title-type-3">
              비밀번호
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6 pr-16">
              <v-text-field
                class="input-custom-2"
                type="password"
                height="40px"
                v-model="passwordFirst"
                :rules="passwordRules"
                solo
                required
                placeholder="영대/소문자, 숫자, 특수문자 중 2종류 이상 조합하여 최소 10자리 이상"
                :error-messages="passwordErrorMessage"
              ></v-text-field>
              <v-text-field
                class="input-custom-2"
                type="password"
                height="40px"
                v-model="passwordConfirm"
                :rules="passwordRulesConfirm"
                solo
                required
                placeholder="비밀번호 확인"
                :error-messages="passwordConfirmErrorMessage"
              ></v-text-field>
            </div>
          </div>
          <div class="form-group mb-8">
            <h3 class="title-type-3">
              담당자 성명
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6 pr-16">
              <v-text-field
                class="input-custom-2"
                type="text"
                height="40px"
                v-model="managerName"
                :rules="mamagerNameRules"
                solo
                required
              ></v-text-field>
            </div>
          </div>
          <div class="form-group mb-8">
            <h3 class="title-type-3">
              권한분류
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6 pr-16">
              <template v-if="isOwner">
                <v-select
                  required
                  :items="searchSelForOwner"
                  label="선택"
                  v-model="searchSelChoice"
                  item-color="#000"
                  class="input-custom-2"
                  height="40px"
                  solo
                ></v-select>
              </template>
            </div>
          </div>
        </div>
        <!--//form-wrap-->
        <!--form-wrap-->
        <div v-if="this.searchSelChoice === 'User'" class="form-wrap">
          <div class="form-group mb-8">
            <h3 class="title-type-3">
              소속
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </h3>
            <div class="relative white rounded pa-6 pr-16 d-flex">
              <div class="pr-2">
                <v-text-field
                  required
                  class="input-custom-2"
                  height="40px"
                  v-model="adviertierName"
                  solo
                  readonly
                  style="width: 450px"
                ></v-text-field>
              </div>
              <v-btn
                large
                depressed
                max-height="40px"
                color="#fecd06"
                class="button-type-1"
                @click.stop="openPopup"
              >
                찾기
              </v-btn>
            </div>
          </div>
        </div>
        <!--//form-wrap-->

        <!--btn-group-->
        <div class="d-flex justify-end mt-10">
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fff"
            class="button-type-1"
            @click.stop="cancel"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            color="#fecd06"
            class="button-type-1 ml-4"
            :disabled="!valid || !searchSelChoice"
            @click.prevent="registerUser"
          >
            저장
          </v-btn>
        </div>
        <!--//btn-group-->
      </v-form>
    </div>
    <div v-if="this.searchAdveriser">
      <SearchAdvertiserModal
        v-model="searchAdveriser"
        @select:advertiser="selectAdvertiser"
      />
    </div>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import { createUser } from '@/api/account';
import { validatePasword } from '@/utils/validation';
import SearchAdvertiserModal from '~@/modal/SearchAdvertiserModal';
import bus from '@/utils/bus.js';
import SystemAlert from '~@/modal/SystemAlert.vue';

export default {
  components: {
    SearchAdvertiserModal,
    SystemAlert,
  },
  data: () => ({
    valid: false,

    searchAdveriser: false,

    searchSelForOwner: ['Owner', 'Admin', 'Developer', 'User'],
    searchSelForAdmin: ['Admin', 'Developer', 'User'],
    searchSelForUser: ['User'],
    searchSelChoice: 'User',

    list: {},
    userId: '',
    idRules: [
      v => !!v || '아이디를 입력해주세요.',
      v =>
        (v && /^[A-Za-z0-9]{6,20}$/.test(v)) ||
        '6~20자 영문(대,소문자 구분)/숫자만 사용 가능합니다.',
    ],

    passwordFirst: '',
    passwordRules: [v => !!v || '비밀번호를 입력해주세요.'],
    passwordConfirm: '',
    passwordRulesConfirm: [v => !!v || '비밀번호를 확인해주세요.'],

    managerName: '',
    mamagerNameRules: [v => !!v || '담당자 성명을 입력해 주세요.'],

    adviertierName: '',
    adviertierId: '',
    showSystemAlert: false,
    logResult: '',
    resultType: null,
  }),
  computed: {
    isValid() {
      return !(
        this.userId ||
        this.passwordFirst ||
        this.passwordConfirm ||
        this.managerName ||
        this.searchSelChoice
      );
    },
    passwordErrorMessage() {
      let str = '';
      if (this.passwordFirst && !validatePasword(this.passwordFirst)) {
        str =
          '영대/소문자, 숫자, 특수문자 중 2종류 이상 조합하여 최소 10자리 이상 입력해주세요.';
      }
      return str;
    },
    passwordConfirmErrorMessage() {
      let str = '';
      if (this.passwordConfirm && !validatePasword(this.passwordConfirm)) {
        str =
          '영대/소문자, 숫자, 특수문자 중 2종류 이상 조합하여 최소 10자리 이상 입력해주세요.';
      }
      return str;
    },
    isOwner() {
      return this.$store.getters.isOwner;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isDeveloper() {
      return this.$store.getters.isDeveloper;
    },
    isUser() {
      return this.$store.getters.isUser;
    },
  },

  methods: {
    selectAdvertiser(data) {
      this.adviertierName = data.name;
      this.adviertierId = data.id;
    },
    async registerUser() {
      try {
        if (this.passwordFirst !== this.passwordConfirm) {
          this.showSystemAlert = true;
          this.logResult = '비밀번호가 일치하지 않습니다.';
          return;
        } else {
          bus.$emit('start:spinner');
          const userData = {
            user_id: this.userId,
            password: this.passwordConfirm.trim(),
            manager_name: this.managerName.trim(),
            type: this.searchSelChoice.toLowerCase(),
            advertiser: {
              id: this.adviertierId,
            },
          };
          const { data } = await createUser(userData);

          if (data.result === 'success') {
            bus.$emit('end:spinner');
            this.resultType = data.result;
            this.showSystemAlert = true;
            this.logResult = '신규 계정이 발급 되었습니다.';
          }
        }
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
        const { data } = error.response;
        this.resultType = data.result;
        this.showSystemAlert = true;
        if (data.result === 'DuplicatedEntry') {
          this.logResult = '이미 사용중인 아이디가 있습니다.';
        } else if (data.result === 'InvalidPassword') {
          this.logResult =
            '영대/소문자, 숫자, 특수문자 중 2종류 이상 조합하여 최소 10자리 이상 입력해주세요.';
        } else {
          this.logResult =
            '등록 중 에러가 발생했습니다.<br>재시도 부탁드립니다.';
        }
      }
    },

    openPopup() {
      this.searchAdveriser = true;
    },
    closePopup() {
      const type = this.resultType;
      this.showSystemAlert = false;
      if (type === 'success') {
        this.$router.push({ name: 'account' }).catch(() => {});
      }
    },
    cancel() {
      this.$refs.form.reset();
      this.$router.push({ name: 'account' }).catch(() => {});
    },
  },

  created() {},
};
</script>

<style></style>
